import { BUSCAR_TOMADORES } from '../../actions/types'

const initialState = undefined

export default function reducerBuscarTomadores (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_TOMADORES: {     
      const tomadores = action.payload.data;
      if (tomadores) {
        return tomadores;
      }
      return []
    }
    default: {
      return state
    }
  }
}